<template>
  <el-table-column
    prop="storage.name"
    sortable="custom"
    label="Raktár"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.storage && scope.row.storage.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'storage.name',
  };
</script>
